import { pick } from "~/core/i18n";

export function issueLabel(issue: string, locale: "en" | "zh") {
	const copy: Record<string, [string, string]> = {
		inline_image_conversion: [
			"Inline images are delivered as attachments; verify their placement in the destination.",
			"正文插图将作为附件交付，请在目标平台确认插入位置。",
		],
		media_spec_review: [
			"Check media dimensions, file size and duration against the destination's current requirements.",
			"请根据目标平台当前要求检查素材分辨率、文件大小和时长。",
		],
		media_required: ["This platform requires media.", "此平台需要素材文件。"],
		media_count: ["Adjust the number of attachments.", "需要调整附件数量。"],
		media_type: ["The selected media type is not accepted.", "所选素材类型不符合平台要求。"],
		weighted_length_review: ["Review this platform's weighted text count.", "请检查平台的加权字数。"],
		video_not_rendered: ["Render the storyboard to a video file first.", "请先将分镜合成为视频文件。"],
		platform_fields: ["Complete the platform fields and destination URL.", "请完善平台字段和目标地址。"],
	};
	if (issue.startsWith("media_spec:"))
		return `${pick(locale, ["Media outside platform specifications", "素材不符合平台规格"])}: ${issue.slice(11)}`;
	return copy[issue]
		? pick(locale, copy[issue])
		: `${pick(locale, issue.startsWith("length:") ? ["Text limit exceeded", "文字超限"] : ["Required field", "必填字段"])}: ${issue.split(":")[1] ?? issue}`;
}
